import { useState } from "react";
import { Info, X } from "lucide-react";

/**
 * Small info button that reveals a contextual help popover for the current page.
 *
 * Usage:
 *   <PageHelp title="Produits" emoji="📦">
 *     <p>Deux onglets : <b>Catalogue</b> et <b>Détails des coûts</b>.</p>
 *     ...
 *   </PageHelp>
 */
const PageHelp = ({ title, emoji = "💡", children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="p-2 rounded-full text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 transition-colors"
        aria-label="À propos de cette page"
        data-testid="page-help-btn"
      >
        <Info className="w-4 h-4" />
      </button>

      {open && (
        <>
          {/* Click outside to close */}
          <div
            className="fixed inset-0 z-40"
            onClick={() => setOpen(false)}
          />
          <div
            className="absolute left-0 top-11 z-50 w-80 md:w-96 bg-white rounded-xl shadow-xl border border-slate-200 overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200"
            data-testid="page-help-panel"
          >
            <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-indigo-50 to-white border-b">
              <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">
                <span className="text-base">{emoji}</span>
                <span>{title}</span>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="p-1 rounded-md text-slate-400 hover:text-slate-600 hover:bg-slate-100"
                aria-label="Fermer"
                data-testid="page-help-close"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="px-4 py-3 text-sm text-slate-600 space-y-3 max-h-[60vh] overflow-y-auto">
              {children}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PageHelp;
